import { createContext } from 'react';
import initialPointsOfSaleState from './initialPointsOfSaleState';

const PointsOfSaleContext = createContext(initialPointsOfSaleState);

export default PointsOfSaleContext;
